import axios from 'axios';
import { getIsApiPending } from '../../../selectors/travelUg/payloadCollection';
import {
    apiTransitionPayloadCollection,
    submitPayloadDataSuccess,
    submitPayloadDataFailure,
} from '../../../actions/travelUg/payloadCollection';
import { getAccessToken, getPaymentMode, getPaymentStatusData, getStkData } from '../../../selectors/travelUg/payments';
import { getCountries, getPremiumCalculation, getQuoteForm } from '../../../selectors/travelUg/quote';
import { getAgentForm } from '../../../selectors/travelUg/travelAgentModal';
import { getCustomer, getTravelDetailsForm, getTravellers } from '../../../selectors/travelUg/travelDetails';
import { getNextOfKinForm } from '../../../selectors/travelUg/nextOfKin';
import { triggerDocumentUploadChecks } from '../../../actions/travelUg/travelDetails';
import { orderConfirmationService } from './orderConfirmation';
import { setBankDetailsSuccess } from '../../../actions/travelUg/payments';

export const payloadSubmitService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                (async () => {
                    store.dispatch(triggerDocumentUploadChecks());
                })();
                const resp = await makeSubmission(store.getState());

                store.dispatch(submitPayloadDataSuccess(resp.data));
                store.dispatch(apiTransitionPayloadCollection.success());

                const modeOfPayment = getPaymentMode(store.getState());

                if (modeOfPayment === 'Flexipay') {
                    orderConfirmationService(store, next, action);
                } else {
                    store.dispatch(setBankDetailsSuccess(true));
                }
            } catch (e) {
                console.error(e);

                store.dispatch(submitPayloadDataFailure(e));
                store.dispatch(apiTransitionPayloadCollection.failure());
            }
        }
    })();
    return next(action);
};

const getCountryId = (country, countries) => {
    if (country === 'Uganda') {
        return 36;
    }

    const selectedCountry = countries.find((value) => value.name === country);

    return selectedCountry.id;
};

const formatTravellers = (state) => {
    const travellers = getTravellers(state);

    const formattedTravellers = [];

    for (let i = 0; i < travellers.length; i++) {
        const traveller = travellers[i];

        formattedTravellers.push({
            fullName: traveller.fullName.value || 'N/A',
            dateOfBirth: traveller.dob.value || 'N/A',
            passportNumber: traveller.passportNumber.value || 'N/A',
            documents: [{ document: traveller.passportDocumentId.value }],
        });
    }

    return formattedTravellers;
};

const payloadCollection = (state) => {
    const quotation = getQuoteForm(state);
    const agent = getAgentForm(state);
    const travelDetails = getTravelDetailsForm(state);
    const customer = getCustomer(state);
    const nextOfKin = getNextOfKinForm(state);
    const paymentMode = getPaymentMode(state);
    const paymentsData = getPaymentStatusData(state);
    const premiumCalculation = getPremiumCalculation(state);
    const countries = getCountries(state);

    const stkData = getStkData(state);

    const payload = {
        coverType: quotation.selectedCover.value,
        tripType: quotation.tripType.value,
        coverageType: quotation.coverFor.value,
        referredByAgent: agent.name?.value ? true : false,
        agentCode: agent.agentCode?.value ? agent.agentCode.value : 'N/A',
        agentName: agent.name?.value ? agent.name.value : 'N/A',
        age: Number(quotation.age.value) || 0,
        departureCountry: getCountryId(quotation.departureCountry.value, countries),
        destinationCountry: getCountryId(quotation.destinationCountry.value, countries),
        travelStartDate: quotation.departureDate.value,
        travelEndDate: quotation.returnDate.value,
        noOfAdults: Number(quotation.noOfTravellers.value) || 0,
        noOfMinors: Number(quotation.noOfMinors.value) || 0,
        nationalityType: travelDetails.nationalityType.value || 'N/A',
        fullName: customer.fullName.value || 'N/A',
        dateOfBirth: customer.dob.value || 'N/A',
        nationalIdNumber: travelDetails.idNumber.value || 'N/A',
        passportNumber: customer.passportNumber.value || 'N/A',
        taxIdentificationNumber: travelDetails.tinNumber.value || 'N/A',
        occupation: travelDetails.profession.value || 'N/A',
        phoneNumber: travelDetails.phoneNumber.value || 'N/A',
        officeNumber: travelDetails.officeNumber.value || 'N/A',
        email: customer.email.value || 'N/A',
        address: travelDetails.postalAddress.value || 'N/A',
        town: travelDetails.town.value || 'N/A',
        bankName: travelDetails.bankName.value || 'N/A',
        bankAccountName: travelDetails.bankHolderName.value || 'N/A',
        bankAccountNumber: travelDetails.bankAccountNumber.value || 'N/A',
        bankBranch: travelDetails.bankBranch.value || 'N/A',
        bankAccountCurrency: travelDetails.bankAccountCurrency.value || 'N/A',
        nextOfKinFullName: nextOfKin.firstName?.value ? nextOfKin.firstName.value : 'N/A',
        nextOfKinPhoneNumber: nextOfKin.phoneNumber?.value || 'N/A',
        nextOfKinEmail: nextOfKin.email?.value || 'N/A',
        nextOfKinOfficeNumber: 'N/A',
        nextOfKinAddress: nextOfKin.postalAddress?.value || 'N/A',
        nextOfKinTown: 'N/A',
        nextOfKinRelationship: nextOfKin.relationship?.value || 'N/A',
        modeOfPayment: paymentMode.toUpperCase().trim(),
        transactionRef: paymentsData?.flexipayReferenceNumber ? stkData?.flexiPayReferenceNumber : 'N/A',
        quoteCode: premiumCalculation.value?.products[0].quote_code || 'N/A',
        quoteIdentification: premiumCalculation.value?.quoteIdentification || 'N/A',
        documents: [{ document: travelDetails.idDocumentId.value }, { document: customer.passportDocumentId.value }],
        additionalTravellers: formatTravellers(state),
        personalDataConsent: travelDetails.personalDataProcessingConsent.value,
        childDataConsent: travelDetails.childDataProcessingConsent.value,
        marketingConsent: travelDetails.marketingUseConsent.value,
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ug/onboarding';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
